import { isValidElement } from 'react';

import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

import { cn } from '@utils/cn';

import { chartWrapper } from '../Chart.styles';
import type { LineChartsProps } from '../Chart.types';

import { CustomTooltip } from './CustomTooltip';

export const LinesChart = ({
  showLegend,
  size,
  tooltip,
  className,
  ...chartProps
}: LineChartsProps) => {
  return (
    <div className={cn(chartWrapper(), className)}>
      <ResponsiveContainer debounce={100} width="100%" height={size?.height || 300}>
        <LineChart {...chartProps?.lineChart}>
          <CartesianGrid vertical={false} />
          <XAxis tickLine={false} axisLine={false} {...chartProps?.xAxis} />
          <YAxis tickLine={false} axisLine={false} {...chartProps?.yAxis} />
          <Tooltip content={isValidElement(tooltip) ? tooltip : <CustomTooltip />} />
          {showLegend === true && <Legend />}
          {(chartProps?.dataset || []).map((set, index) => (
            <Line
              key={index}
              type="natural"
              dataKey={set.dataKey}
              stroke={set.color}
              strokeWidth={2}
              dot={{ fill: set.color }}
              activeDot={{ r: 6 }}
              {...set}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
